export default {
  addRole: '役割追加',
  id: 'ID',
  role: '役割',
  actions: '操作',
  edit: '編集',
  delete: '削除',
  addRoleTitle: '役割追加',
  editRoleTitle: '役割編集',
  roleName: '役割名',
  roleNamePlaceholder: '役割名を入力してください',
  rolePermissions: '役割権限',
  cancel: 'キャンセル',
  confirm: '確認',
  level1Menu: '第1階層メニュー',
  level2Menu: '第2階層メニュー',
  confirmDelete: 'この役割を削除してもよろしいですか？',
};
